export const PATIENT_PORTAL = "https://scv.apple-wellnesscenter.com";

export const US_LOCATIONS = {
  "Austin": "https://care.crossoverhealth.com",
  "Sacramento": "https://care.crossoverhealth.com",
  "Cupertino/SCV": PATIENT_PORTAL,
  "On Demand Care - National": PATIENT_PORTAL,
  "Austin & Sacramento Legacy Portal": "https://go.crossoverhealth.com"
};

export const INTERNATIONAL_LOCATIONS = {
  "Ireland": "https://cork.apple-wellnesscenter.com/home",
  "London": "https://patientbooking.co.uk/uk-apple-wellnesscentre/#/login",
  "Shanghai": "https://apple.shanghaiwellnesscenter.com",
  "Singapore": "https://fhnxapp.web.app",
  "Singapore Legacy Portal": "https://singapore.apple-wellnesscenter.com"
};
